import { render, staticRenderFns } from "./HistoricoParametro.vue?vue&type=template&id=06122ff4&"
import script from "./HistoricoParametro.vue?vue&type=script&lang=js&"
export * from "./HistoricoParametro.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoParametro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports